export class HighScore
{
    timestamp: number;
    score: number;
    
}
